import { Alert } from "antd"
import { useAuth } from "../../components/context/AuthContext"
import AuthPageLayout, { PrimaryButton } from "./AuthPageLayout"

/** Kunden-Login ohne Portal-Zugangsdatensatz (403 "No customer found for this login"): nur Abmelden, kein erneutes Login-Routing. */
export default function NoCustomer() {
    const auth = useAuth()
    return (
        <AuthPageLayout title="Kein Kundenzugang">
            <Alert
                type="warning"
                showIcon
                message="Ihr Zugang ist keinem Kunden zugeordnet."
                description="Bitte wenden Sie sich an Ihren Ansprechpartner, damit Ihr Zugang eingerichtet wird."
            />
            <PrimaryButton type="button" onClick={() => void auth.logout()}>
                Abmelden
            </PrimaryButton>
        </AuthPageLayout>
    )
}
